import(/* webpackMode: "eager" */ "/codebuild/output/src2767878251/src/app/error.tsx");
